if (!customElements.get('saam-shop-hub')) customElements.define('saam-shop-hub', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  const tabs = [...this.querySelectorAll('[data-hub-tab]')];
  const panels = [...this.querySelectorAll('[data-hub-panel]')];
  if (!tabs.length) return;
  this.querySelector('nav').setAttribute('role', 'tablist');
  const select = (index, focus = false) => {
   tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
   if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, i) => {
   tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panels[i].id);
   panels[i].setAttribute('role', 'tabpanel');
   tab.addEventListener('click', event => { event.preventDefault(); select(i); history.replaceState(null, '', tab.hash); });
   tab.addEventListener('keydown', event => {
    let next;
    if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    if (next !== undefined) { event.preventDefault(); select(next, true); history.replaceState(null, '', tabs[next].hash); }
   });
  });
  const fromHash = () => select(Math.max(0, tabs.findIndex(tab => tab.hash === location.hash)));
  window.addEventListener('hashchange', fromHash);
  fromHash();
 }
});
